import React from 'react';
import postData from "../service/fetcher";

export default class Password extends React.Component {

    constructor(props) {
        super(props);
        this.input = this.input.bind(this);
        this.submit = this.submit.bind(this);
        this.keyPressed = this.keyPressed.bind(this);
    }

    input(e) {
        this.setState({probToken: e.target.value})
    }

    submit() {
        this.setState({loading: true}, () => postData("/api/login", {}, {password: this.state.probToken})[0].then((data) => {
            if (data.correct) {
                this.props.changeToken(data.token);
            } else {
                this.setState({error: "U tikte het verkeerd wacht woord in ", loading: false})
            }
        }).catch(() => this.setState({error: "Het is niet geluk om in te loggen, controleer uw internetverbinding.", loading: false})));
    }

    keyPressed(event) {
        if (event.key === "Enter") this.submit();
    }


    state = {error: undefined, probToken: "", loading: false};

    render() {
        return (
            <div>{!this.state.loading && <div>
                <p className="text">Welkom!</p>
                {this.state.error !== undefined && <p>{this.state.error}</p>}
                <input type="password" onKeyPress={this.keyPressed} onChange={(e) => this.input(e)}
                       placeholder={"Tik uw wachtwoord in!"}/>
                <button onClick={this.submit}>Log in</button>
            </div>}
                {this.state.loading && <p>We zijn u aan het inloggen, even geduld.</p>}
            </div>
        );
    }

}
